import { gql } from '@apollo/client'

export const MONITORING_UPDATE_ACCOMMODATION_QUERY = gql`
  query GetUpdateMonitoringAccommodationLayer(
    $filters: AccommodationLayerFiltersInput!
  ) {
    getUpdateMonitoringAccommodationLayer(filters: $filters) {
      data {
        propertyCode
        accommodationName
        accommodationID
        numberOfRoomType
        channels {
          channelID
          channelName
          dataForEachDate {
            date
            status
            time
          }
        }
        dataForEachDate {
          date
          status
          time
        }
      }
    }
  }
`
export const MONITORING_UPDATE_ROOM_TYPE_QUERY = gql`
  query GetUpdateMonitoringRoomTypeLayer(
    $filters: RoomTypeLayerFiltersInputFiltersInput!
  ) {
    getUpdateMonitoringRoomTypeLayer(filters: $filters) {
      data {
        roomTypeCode
        roomTypeName
        roomTypeID
        numberOfRatePlans
        dataForEachDate {
          date
          status
          time
          availability {
            status
            time
          }
          pooledAvailability {
            status
            time
          }
          totalAllocatedAvailabiliy {
            status
            time
          }
        }
      }
    }
  }
`
export const MONITORING_UPDATE_RATE_PLAN_QUERY = gql`
  query GetUpdateMonitoringRatePlanLayer($filters: RatePlanLayerFiltersInput!) {
    getUpdateMonitoringRatePlanLayer(filters: $filters) {
      data {
        ratePlanCode
        ratePlanName
        ratePlanID
        dataForEachDate {
          date
          status
          time
          restrictions {
            status
            time
          }
          rates {
            status
            time
          }
        }
      }
    }
  }
`
